export const InterviewScheduledContainer = () => {
  return null;
};
